class CollectionView {
  static STORAGE_KEY = 'mitocollar-collection-view';

  static init() {
    const layout = CollectionView.getStoredLayout();
    CollectionView.apply(layout);
    CollectionView.updateToggleButtons(layout);
    CollectionView.bindToggleButtons();
  }

  static getStoredLayout() {
    const stored = localStorage.getItem(CollectionView.STORAGE_KEY);
    return stored === 'list' ? 'list' : 'grid';
  }

  static setLayout(layout) {
    localStorage.setItem(CollectionView.STORAGE_KEY, layout);
    CollectionView.apply(layout);
    CollectionView.updateToggleButtons(layout);
  }

  static apply(layout) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    productGrid.classList.toggle('product-grid--list', layout === 'list');
    productGrid.classList.toggle('product-grid--grid', layout === 'grid');
  }

  static updateToggleButtons(layout) {
    document.querySelectorAll('[data-collection-view]').forEach((button) => {
      const isActive = button.dataset.collectionView === layout;
      button.classList.toggle('collection-view-toggle__button--active', isActive);
      button.setAttribute('aria-pressed', isActive);
    });
  }

  static bindToggleButtons() {
    if (CollectionView.delegationBound) return;

    CollectionView.delegationBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-collection-view]');
      if (!button) return;

      event.preventDefault();
      CollectionView.setLayout(button.dataset.collectionView);
    });
  }
}

CollectionView.init();

document.addEventListener('shopify:section:load', () => {
  CollectionView.init();
});
